import React, {useState} from 'react';
import {Button, Form, Input} from 'antd';
import Auth from '../../http_request/Model/auth/Auth';
import Cookies from 'js-cookie';
import {useNavigate} from 'react-router-dom';
import {decodeToken} from "react-jwt";

const Login = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

const handleRedirect = (permission) => {
    let address = '/'
    switch (permission) {
        case "Map":
            address = '/'
            break;
        case "Qc":
            address = '/Batch'
            break;
        case "Warehouse":
            address = '/'
            break;
        case "Order":
            address = '/order'
            break;
        case "Print":
            address = '/PalletIdProduction'
            break;
        case "ViewPallet":
            address = '/PalletStatus'
            break;

        default:
            address = '/PalletStatus'
    }


    navigate(address);
}
    const onFinish = (values) => {
        Auth.request({
            beforeSend: () => {
                setLoading(true)
            }, success: (result) => {
                Cookies.set('token', result.token)
                let per = decodeToken(result.token).Permission
                Cookies.set('Permission', JSON.stringify(decodeToken(result.token).Permission))
                handleRedirect(typeof per === "string" ? per  :  per[0] )


            }, final: () => {
                setLoading(false)
            }


        }).login(values)
    };


    const onFinishFailed = (errorInfo) => {
    };
    return (
        <Form
            name="basic"
            layout='vertical'
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
        >
            <Form.Item
                label="نام کاربری"
                name="username"
                rules={[
                    {
                        required: true,
                        message: 'لطفا نام کاربری را وارد کنید!',
                    },
                ]}
            >
                <Input/>
            </Form.Item>

            <Form.Item
                label="کلمه عبور"
                name="password"
                rules={[
                    {
                        required: true,
                        message: 'لطفا کلمه عبور را وارد کنید!',
                    },
                ]}
            >
                <Input.Password/>
            </Form.Item>

            <Form.Item

            >
                <div className="flex justify-end">
                    <Button className='defBtn blueBtn w-full' type="primary" htmlType="submit" loading={loading}>
                        ورود
                    </Button>
                </div>
            </Form.Item>
        </Form>
    )
}

export default Login;